import { DirectiveType } from '../../types';
import { AbstractSingleValueDirective } from '../abstract-single-value-directive';
export class ReportUri extends AbstractSingleValueDirective {
    getDirectiveName() {
        return 'report-uri';
    }
    getDirectiveType() {
        return DirectiveType.Reporting;
    }
}
